module.exports = __webpack_public_path__ + "img/base.6f26afa9.png";